const currentTimeInSeconds = () => Date.now() / 1000

export { currentTimeInSeconds }
